import React from 'react';
import styles from './MobileNavbar.module.scss';
import NavbarLink from './NavbarLink';
import { useNavigate } from 'react-router';
import {
  HomeIcon,
  PricingIcon,
  OrdersIcon,
  CommunityIcon,
  MessageIcon,
  GridViewIcon,
  CalendarIcon,
  CalculatorIcon,
  BookmarkIcon,
  ShopCartIcon,
} from 'tt-ui-lib/icons';

import { ReactComponent as GridActiveIcon } from '../../assets/svg/navbar/grid-icon-blue.svg';
import { ReactComponent as PlusGradientIcon } from '../../assets/svg/navbar/plus-gradient-icon.svg';

export const MobileNavbarWrapper = ({
  user,
  setAnchorLoginEl,
  redirectDomain,
  createAnInvitation,
  openCalculator,
  openCalendar,
  openBookmark,
  marketTTUrl,
  digitalAssetsTTUrl,
  qaTTUrl,
}) => {
  const navigate = useNavigate();
  const endpointMarket = process.env.REACT_APP_MARKET || '';

  const redirectMarket = (url) => {
    window.location.href = `${endpointMarket}${url}`;
  };

  const handleLoginClick = (event) => {
    event.preventDefault();
    setAnchorLoginEl(event.currentTarget);

    event.stopPropagation();
  };

  const openCart = () => {
    if (marketTTUrl) {
      redirectMarket(`/dashboard/cart`);
    } else {
      navigate('/dashboard/cart');
    }
  };

  return (
    <div className={styles.mobileNavbar}>
      <NavbarLink
        href={redirectDomain ? `${redirectDomain}/dashboard/feed` : '/dashboard/feed'}
        Icon={HomeIcon}
      />
      <NavbarLink
        href={redirectDomain ? `${redirectDomain}/dashboard/pricing` : '/dashboard/pricing'}
        Icon={PricingIcon}
      />
      <NavbarLink
        href={redirectDomain ? `${redirectDomain}/dashboard/community` : '/dashboard/community'}
        Icon={CommunityIcon}
        onClick={!user.id ? (e) => handleLoginClick(e) : null}
      />
      <NavbarLink
        href={marketTTUrl ? `${marketTTUrl}/dashboard/orders` : '/dashboard/orders'}
        Icon={OrdersIcon}
        onClick={!user.id ? (e) => handleLoginClick(e) : null}
      />
      <NavbarLink
        href={redirectDomain ? `${redirectDomain}/dashboard/messaging` : '/dashboard/messaging'}
        Icon={MessageIcon}
        onClick={!user.id ? (e) => handleLoginClick(e) : null}
      />
      <NavbarLink
        itemIsMenu
        Icon={GridViewIcon}
        IconActive={GridActiveIcon}
        menuItems={
          <>
            {user?.kyc === 'success' ||
            (user?.roles_list && JSON.parse(user?.roles_list).includes('transparenterra')) ? (
              <div onClick={() => createAnInvitation()} className={styles.menuItem}>
                <PlusGradientIcon style={{ width: 20, height: 20 }} />
              </div>
            ) : null}
            <div onClick={() => openCart()} className={styles.menuItem}>
              <ShopCartIcon style={{ width: 20, height: 20 }} />
            </div>
            <div onClick={() => openCalendar()} className={styles.menuItem}>
              <CalendarIcon style={{ width: 20, height: 20 }} />
            </div>
            <div onClick={() => openCalculator()} className={styles.menuItem}>
              <CalculatorIcon style={{ width: 20, height: 20 }} />
            </div>
            <div onClick={() => openBookmark()} className={styles.menuItem}>
              <BookmarkIcon style={{ width: 20, height: 20 }} />
            </div>
          </>
        }
        onClick={!user.id ? (e) => handleLoginClick(e) : null}
      />
    </div>
  );
};
